import { Footer } from '@hhgtech/hhg-components/components'
import LazyHydrate from 'react-lazy-hydration'

import ErrorBoundary from 'components/templates/navigatorLayout/errorBoundary'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { basePath } from 'interfaces/constants'
import { FooterInfo } from 'interfaces/types'

export type Props = {
  footerInfo?: FooterInfo
}

const NavFooter = ({
  footerInfo,
}: // hideWelcomePopup,
Props) => {
  const { locale } = useRouterExtend()

  return (
    <>
      {footerInfo && (
        <ErrorBoundary>
          <LazyHydrate ssrOnly>
            <Footer
              footerInfo={footerInfo}
              locale={locale}
              siteType="helloSites"
              type="main"
              basePath={basePath}
            />
          </LazyHydrate>
        </ErrorBoundary>
      )}
    </>
  )
}

export { NavFooter }
